//  通道回调配置- page
import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs.ts'

// 通道回调配置
export const getSeatIpConfigPage = options => {
  return request(UrlConfig.PlusCrmWeb.GetSeatIpConfigPage, {
    method: METHODS.POST,
    ...options,
  })
}
export const getSeatIpConfigList = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.GetSeatIpConfigList, {
    method: METHODS.POST,
    data,
  })
}
export const seatIpConfigSave = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.SeatIpConfigSave, {
    method: METHODS.POST,
    data,
  })
}
export const seatIpConfigDel = id => {
  return request(UrlConfig.PlusCrmWeb.SeatIpConfigDel + id, {
    method: METHODS.DELETE,
  })
}
export const seatIpConfigUpdate = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.SeatIpConfigUpdate, {
    method: METHODS.POST,
    data,
  })
}

// 坐席配置
export const getSeatAccountPage = options => {
  return request(UrlConfig.PlusCrmWeb.GetSeatAccountPage, {
    method: METHODS.POST,
    ...options,
  })
}
export const getSeatAccountList = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.GetSeatAccountList, {
    method: METHODS.POST,
    data,
  })
}

export const seatAccountSave = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.SeatAccountSave, {
    method: METHODS.POST,
    data,
  })
}
export const seatAccountDel = id => {
  return request(UrlConfig.PlusCrmWeb.SeatAccountDel + id, {
    method: METHODS.DELETE,
  })
}
export const seatAccountUpdate = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.SeatAccountUpdate, {
    method: METHODS.POST,
    data,
  })
}

// 获取坐席
export const getSeatWorkerList = (data = {}): Promise<any[]> => {
  return request(UrlConfig.Caas.GetNoPrivilegesList, {
    method: METHODS.POST,
    data,
  })
}
// 销售工作台
export const salesWorkPage = options => {
  return request(UrlConfig.PlusCrmWeb.salesWorkPage, {
    method: METHODS.POST,
    ...options,
  })
}
export const getBizStatus = () => {
  return request(UrlConfig.PlusCrmWeb.getBizStatus, {
    method: METHODS.GET,
  })
}
export const getBizOrder = options => {
  return request(UrlConfig.PlusCrmWeb.getBizOrder, {
    method: METHODS.POST,
    ...options,
  })
}
export const queryTrackPlan = data => {
  return request(UrlConfig.PlusCrmWeb.queryTrackPlan, {
    method: METHODS.POST,
    data,
  })
}
export const batchAssignDesigner = data => {
  return request(UrlConfig.PlusCrmWeb.batchAssignDesigner, {
    method: METHODS.POST,
    data,
  })
}
// 商机运营
export const getCluePage = options => {
  return request(UrlConfig.PlusCrmWeb.GetCluePage, {
    method: METHODS.POST,
    ...options,
  })
}
// 商机运营 -导出
export const clueExport = data => {
  return request(UrlConfig.PlusCrmWeb.ClueExport, {
    method: METHODS.POST,
    responseType: 'arraybuffer',
    raw: true,
    data,
  })
}
// 导出包/记录
export const importExportTaskDownloadExcel = data => {
  return request(UrlConfig.Export.ImportExportTaskDownloadExcel, {
    method: METHODS.POST,
    responseType: 'arraybuffer',
    raw: true,
    data,
  })
}
// 根据线索id查询按钮
export const getClueButton = clueId => {
  return request(UrlConfig.PlusCrmWeb.GetClueButton + clueId, {
    method: METHODS.POST,
  })
}

// 是否有编辑楼盘的权限
export const getEditBuildingPermission = clueId => {
  return request(UrlConfig.PlusCrmWeb.GetEditBuildingPermission + clueId, {
    method: METHODS.GET,
  })
}

export const addClue = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.AddClue, {
    method: METHODS.POST,
    data,
  })
}
export const clueBatchAssign = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.ClueBatchAssign, {
    method: METHODS.POST,
    data,
  })
}
export const updateClue = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.UpdateClue, {
    method: METHODS.POST,
    data,
  })
}
export const getClueDetail = id => {
  return request(UrlConfig.PlusCrmWeb.GetClueDetail + id, {
    method: METHODS.GET,
  })
}
export const getTagsByClueId = clueId => {
  return request(UrlConfig.PlusCrmWeb.GetTagsByClueId + clueId, {
    method: METHODS.GET,
  })
}
export const updateClueTag = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.UpdateClueTag, {
    method: METHODS.POST,
    data,
  })
}
export const getSalesTemplateList = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.GetSalesTemplateList, {
    method: METHODS.POST,
    data,
  })
}
export const getAllRelatives = clueId => {
  return request(UrlConfig.PlusCrmWeb.GetAllRelatives + clueId, {
    method: METHODS.GET,
  })
}

export const clueSalesValid = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.ClueSalesValid, {
    method: METHODS.POST,
    data,
  })
}

// 已入库线索
export const getAllCluePage = options => {
  return request(UrlConfig.PlusCrmWeb.GetAllCluePage, {
    method: METHODS.POST,
    ...options,
  })
}
// 导出
export const allClueExport = data => {
  return request(UrlConfig.PlusCrmWeb.AllClueExport, {
    method: METHODS.POST,
    responseType: 'arraybuffer',
    raw: true,
    data,
  })
}
// 销运数据权限
export const orgPermissionsPage = options => {
  return request(UrlConfig.PlusCrmWeb.OrgPermissionsPage, {
    method: METHODS.POST,
    ...options,
  })
}
export const orgPermissionsSave = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.OrgPermissionsSave, {
    method: METHODS.POST,
    data,
  })
}
export const orgPermissionsDel = (id) => {
  return request(UrlConfig.PlusCrmWeb.OrgPermissions + id, {
    method: METHODS.DELETE,
  })
}
export const orgPermissionsUpdate = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.OrgPermissionsUpdate, {
    method: METHODS.POST,
    data,
  })
}
// 销运数据权限-添加人员
export const employeePermissionsPage = options => {
  return request(UrlConfig.PlusCrmWeb.EmployeePermissionsPage, {
    method: METHODS.POST,
    ...options,
  })
}
export const employeePermissionsSave = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.EmployeePermissionsSave, {
    method: METHODS.POST,
    data,
  })
}
export const employeePermissions = (id) => {
  return request(UrlConfig.PlusCrmWeb.EmployeePermissions + id, {
    method: METHODS.DELETE,
  })
}
export const employeePermissionsUpdate = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.EmployeePermissionsUpdate, {
    method: METHODS.POST,
    data,
  })
}
// 入库前线索
export const getBeforeCluePage = (options) => {
  return request(UrlConfig.PlusClueWeb.GetBeforeCluePage, {
    method: METHODS.POST,
    ...options,
  })
}
export const beforeClueResend = (id) => {// 手动推送入库
  return request(UrlConfig.PlusClueWeb.BeforeClueResend + id, {
    method: METHODS.POST,
  })
}
// 飞单列表
export const getInvalidPage = (options) => {
  return request(UrlConfig.PlusCrmWeb.GetInvalidPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 销售计划详情查询按钮
export const getTrackPlanButton = (trackPlanId): Promise<any[]> => {
  return request(UrlConfig.PlusCrmWeb.GetTrackPlanButton + trackPlanId, {
    method: METHODS.POST,
  })
}
// 派单异常
export const getDispatchExceptionPage = options => {
  return request(UrlConfig.PlusCrmWeb.GetDispatchExceptionPage, {
    method: METHODS.POST,
    ...options,
  })
}
export const callReceive = (clueId) => {
  return request(UrlConfig.PlusCrmWeb.CallReceive + clueId, {
    method: METHODS.POST,
  })
}
export const dispatchClueAgain = (data) => {
  return request(UrlConfig.PlusCrmWeb.DispatchClueAgain, {
    method: METHODS.POST,
    data
  })
}
// 撞单异常
export const getCollisionPage = options => {
  return request(UrlConfig.PlusCrmWeb.GetCollisionPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 无效列表
export const getClueInvalidPage = options => {
  return request(UrlConfig.PlusCrmWeb.GetClueInvalidPage, {
    method: METHODS.POST,
    ...options,
  })
}
export const designerReceive = trackPlanId => {
  return request(UrlConfig.PlusCrmWeb.DesignerReceive + trackPlanId, {
    method: METHODS.POST,
  })
}
export const lostDispatch = data => {
  return request(UrlConfig.PlusCrmWeb.LostDispatch, {
    method: METHODS.POST,
    data,
  })
}
export const lostBatchDispatch = data => {
  return request(UrlConfig.PlusCrmWeb.LostBatchDispatch, {
    method: METHODS.POST,
    data,
  })
}
export const designerBatchReceive = data => {
  return request(UrlConfig.PlusCrmWeb.DesignerBatchReceive, {
    method: METHODS.POST,
    data,
  })
}
export const getDispatchMnrList = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.GetDispatchMnrList, {
    method: METHODS.POST,
    data,
  })
}
export const getSeatAccount = userId => {
  return request(UrlConfig.PlusCrmWeb.GetSeatAccount + userId, {
    method: METHODS.GET,
  })
}
export const checkRepeatByPhone = phone => {
  return request(UrlConfig.PlusCrmWeb.CheckRepeatByPhone + phone, {
    method: METHODS.GET,
  })
}
// 销售工作台-获取预约到店数据
export const getAppointmentData = (data = {}) => {
  return request(UrlConfig.PlusCrmWeb.getAppointmentData, {
    method: METHODS.POST,
    data,
  })
}
// 销售工作台-到店列表
export const appointmentPage = options => {
  return request(UrlConfig.PlusCrmWeb.appointmentPage, {
    method: METHODS.POST,
    ...options,
  })
}
// 销售工作台-获取全部紧急任务
export const getTaskAll = (userId: string) => {
  return request(`${UrlConfig.PlusCrmWeb.getTaskAll}?userId=${userId}`, {
    method: METHODS.GET,
  })
}
// 销售工作台-获取全部紧急任务
export const getTaskLimit = (userId: string, limit: number) => {
  return request(`${UrlConfig.PlusCrmWeb.getTaskLimit}?userId=${userId}&limit=${limit}`, {
    method: METHODS.GET,
  })
}
// 销售工作台-获取处理任务
export const getTaskId = (id: string) => {
  return request(UrlConfig.PlusCrmWeb.getTaskId + id, {
    method: METHODS.GET,
  })
}

//外呼工作量统计
export const getSeatWorkload = data => {
  return request(UrlConfig.Report.GetSeatWorkload, {
    method: METHODS.POST,
    data
  })
}
// 通话监控
export const getMonitor = data => {
  return request(UrlConfig.Report.GetMonitor, {
    method: METHODS.POST,
    data
  })
}
